export function Switch({ value, onChange }: { value: boolean, onChange: (value: boolean) => void }) {
    return <div className={`switch ${value ? "on" : "off"}`} onClick={() => onChange(!value)} />;
}
